<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <h5 class="mb-0"><i class="fa fa-fw fa-book mr-2" />Laporan 3 Bulanan</h5>
            <small>
                *Catatan: Pilih tanggal yang menentukan bulan terakhir laporan. Laporan 3 Bulanan mencakup tiga bulan berturut-turut.
                <br />
                (Contoh: Jika memilih tanggal antara 1-28 Februari, maka laporan untuk Desember, Januari, dan Februari.)
            </small>
            <hr />
            <b-row>
                <b-col md="12">
                    <b-form-group style="margin-bottom: 0;" label="Tgl. Laporan 3 Bulanan *">
                        <b-form-input type="date" v-model="filter.current_date" />
                    </b-form-group>
                </b-col>
            </b-row>
            <hr />
            <b-row>
                <b-col md="4">
                    <b-form-group label="Ada Kerusakan">
                        <b-form-select v-model="filter.hasDamage" :options="optHasDamage" />
                    </b-form-group>
                </b-col>
                <b-col md="4">
                    <b-form-group label="Spek">
                        <multiselect :multiple="true" :close-on-select="false" v-model="filter.specs" label="name"
                        track-by="id" :internal-search="true" deselect-label="" select-label="" :options="optSpec" />
                    </b-form-group>
                </b-col>
                <b-col md="4">
                    <b-form-group label="Jenis">
                        <multiselect v-model="filter.kind" label="name" track-by="id" :internal-search="true"
                        deselect-label="" select-label="" :options="optKind" />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="4">
                    <b-form-group label="Kelengkapan">
                        <b-form-select v-model="filter.isBatangan" :options="optIsBatangan" />
                    </b-form-group>
                </b-col>
                <b-col md="4">
                    <b-form-group label="Gudang">
                        <multiselect v-model="filter.warehouse" label="name" track-by="id" :internal-search="true"
                            deselect-label="" select-label="" :options="optWarehouse" />
                    </b-form-group>
                </b-col>
                <b-col md="4">
                    <b-form-group label="Grade">
                        <multiselect :multiple="true" :close-on-select="false" v-model="filter.grade" label="name"
                            track-by="id" :internal-search="true" deselect-label="" select-label=""
                            :options="optGrade" />
                    </b-form-group>
                </b-col>
            </b-row>
            <div>
                <b-button variant="dark" class="mr-2 mb-2" @click="generateReportSales">
                    <i class="fa fa-download mr-2" /> Laporan 3 Bulanan
                </b-button>
            </div>
        </b-card>
        <b-modal id="m-download" :title="modalTitle" centered no-close-on-backdrop no-close-on-esc hide-footer>
            <div v-if="status == 0">
                Menyiapkan laporan, mohon menunggu...
            </div>
            <div v-else-if="status == -1">
                Gagal menyiapkan laporan. Silahkan coba lagi.
            </div>
            <div v-else>
                Laporan sudah siap. Tekan tombol dibawah ini untuk download laporan Excel.
                <div class="mt-2">
                    <a :href="$BASE_FILE_PATH + path" download>
                        <b-button variant="primary">
                            <i class="fa fa-download mr-2" />Download Excel Laporan
                        </b-button>
                    </a>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>

export default {
    data() {
        return {

            initStatus: 0,
            status: 1,
            path: "",
            modalTitle: "",
            filter: {
                current_date: null,
                grade: [],
                warehouse: null,
                hasDamage: null,
                specs: [],
                kind: null,
                isBatangan: null,
            },
            optGrade: [
                { id: "S", name: "S" },
                { id: "A", name: "A" },
                { id: "B", name: "B" },
                { id: "C", name: "C" },
                { id: "X", name: "X" },
            ],
            optHasDamage: [
                { value: null, text: "Semua" },
                { value: 1, text: "Ya" },
                { value: 0, text: "Tidak" },
            ],
            optIsBatangan: [
                { value: null, text: "Semua" },
                { value: 1, text: "Lengkap" },
                { value: 0, text: "Batangan" }
            ],
            optWarehouse: [],
            optSpec: [],
            optKind: [],
        }
    },
    methods: {
        init() {
            this.initStatus = 0
            let getWarehouse = this.$axios.get("master/warehouse/selection").then(res => {
                this.optWarehouse = res.data.data.map(it => {
                    return { id: it.id, name: `${it.name} - ${it.office_name}` }
                })
            })

            let getSpecs = this.$axios.get("master/spec/selection").then(res => {
                this.optSpec = res.data.data
            })

            let getKinds = this.$axios.get("master/kinds").then(res => {
                this.optKind = res.data.data
            })

            Promise.all([getWarehouse, getSpecs, getKinds])
            .then(_ => this.initStatus = 1)
            .catch(_ => this.initStatus = -1)

        },
        generateReportSales() {

            this.modalTitle = "Laporan 3 Bulanan"

            if (!this.filter.current_date) {
                return this.$helper.toastError(this, "Mohon lengkapi tanggal laporan!")
            }

            let payload = {
                current_date: this.filter.current_date,
                grade: this.filter.grade.map(it => it.id),
                warehouse_id: this.filter.warehouse ? this.filter.warehouse.id : null,
                has_damaged: this.filter.hasDamage,
                item_spec_ids: this.filter.specs.map(it => it.id),
                item_kind_id: this.filter.kind ? this.filter.kind.id : null,
                is_batangan: this.filter.isBatangan,
            }

            this.$bvModal.show("m-download")
            this.status = 0
            this.$axios.post("report/three-month", payload, { timeout: 600000 }).then(res => {
                this.status = 1
                this.path = res.data.data.path

            })
            .catch(error => {
                this.status = -1
                this.$helper.parseError(this, error)
            })

        },
    },
    created() {
        this.init()
    }
}
</script>
